// extracted by mini-css-extract-plugin
export default {"notification_container":"NotificationPage_notification_container__xYOea","footerWrapper":"NotificationPage_footerWrapper__kEsEZ"};